import React from "react";
import './bibleverse.css';
import { Containercstm, ContainerWidthCstm, TitleinMaindiv } from "../extra";

export const BibleVerseComp = () => {

    return(

        <>
            <TitleinMaindiv title={"Bible Verse"} initialtitle={"Home"} />
            <Containercstm>
                <ContainerWidthCstm>
                    <BibleVersetoStarttheDay />
                    <BibleVersePositivity />
                    <BibleVerseStrenthandEndurance />
                    <BibleVerseAnxietyandWorry />
                    <BibleVerseHopeinDifficultTimes />
                </ContainerWidthCstm>
            </Containercstm>
        </>
    )
}


export const BibleVersetoStarttheDay = () => {

    return(
        
        <>
            <h1 className="text_cstm_big_heading">Bible Verses To Start The Day</h1>
            <h1 className="text_cstm_medium_heading primarycolorcstm">Lamentations 3:22-23</h1>
            <p className="text_cstm_normal_para textalign_cstmjustify">“His mercies are new every morning; great is your faithfulness.”</p>
            <h1 className="text_cstm_medium_heading primarycolorcstm">Psalm 118:24</h1>
            <p className="text_cstm_normal_para textalign_cstmjustify">“This is the day the Lord has made; let us rejoice and be glad in it.”</p>
            <h1 className="text_cstm_medium_heading primarycolorcstm">Mark 1:35</h1>
            <p className="text_cstm_normal_para textalign_cstmjustify">“Very early in the morning... Jesus got up, left the house and went off to a solitary place, where he prayed”</p>
            <h1 className="text_cstm_medium_heading primarycolorcstm">Proverbs 3:5-6</h1>
            <p className="text_cstm_normal_para textalign_cstmjustify">"Trust in the Lord with all your heart... he will make your paths straight.”</p>
            <h1 className="text_cstm_medium_heading primarycolorcstm">Isaiah 50:4</h1>
            <p className="text_cstm_normal_para textalign_cstmjustify">“He awakens me morning by morning, wakens my ear to listen like one being instructed.”</p>
        </>
    )
}

export const BibleVersePositivity = () => {

    return(
        
        <>
            <h1 className="text_cstm_big_heading">Bible Verses For Positivity</h1>
            <h1 className="text_cstm_medium_heading primarycolorcstm">Philippians 4:8</h1>
            <p className="text_cstm_normal_para textalign_cstmjustify">“Whatever is true... lovely... admirable if anything is excellent or praiseworthy think about such things.”</p>
            <h1 className="text_cstm_medium_heading primarycolorcstm">Romans 12:12</h1>
            <p className="text_cstm_normal_para textalign_cstmjustify">“Be joyful in hope, patient in affliction, faithful in prayer.”</p>
            <h1 className="text_cstm_medium_heading primarycolorcstm">Nehemiah 8:10</h1>
            <p className="text_cstm_normal_para textalign_cstmjustify">“The joy of the Lord is your strength.”</p>
            <h1 className="text_cstm_medium_heading primarycolorcstm">Psalm 16:11</h1>
            <p className="text_cstm_normal_para textalign_cstmjustify">“In your presence there is fullness of joy.”</p>
            <h1 className="text_cstm_medium_heading primarycolorcstm">John 16:33</h1>
            <p className="text_cstm_normal_para textalign_cstmjustify">"Take heart! I have overcome the world.”</p>
        </>
    )
}

export const BibleVerseStrenthandEndurance = () => {

    return(
        
        <>
            <h1 className="text_cstm_big_heading">Bible Verses For Strength And Endurance</h1>
            <h1 className="text_cstm_medium_heading primarycolorcstm">Isaiah 40:31</h1>
            <p className="text_cstm_normal_para textalign_cstmjustify">“Those who hope in the Lord will renew their strength...”</p>
            <h1 className="text_cstm_medium_heading primarycolorcstm">2 Corinthians 12:9</h1>
            <p className="text_cstm_normal_para textalign_cstmjustify">“My grace is sufficient for you, for my power is made perfect in weakness.”</p>
            <h1 className="text_cstm_medium_heading primarycolorcstm">Philippians 4:13</h1>
            <p className="text_cstm_normal_para textalign_cstmjustify">“I can do all things through Christ who strengthens me.”</p>
            <h1 className="text_cstm_medium_heading primarycolorcstm">Psalm 18:32</h1>
            <p className="text_cstm_normal_para textalign_cstmjustify">“It is God who arms me with strength and keeps my way secure.”</p>
            <h1 className="text_cstm_medium_heading primarycolorcstm">Joshua 1:9</h1>
            <p className="text_cstm_normal_para textalign_cstmjustify">"Be strong and courageous... the Lord your God will be with you wherever you go.”</p>
        </>
    )
}


export const BibleVerseAnxietyandWorry = () => {

    return(
        
        <>
            <h1 className="text_cstm_big_heading">Bible Verses For Anxiety And Worry</h1>
            <h1 className="text_cstm_medium_heading primarycolorcstm">Matthew 6:34</h1>
            <p className="text_cstm_normal_para textalign_cstmjustify">“Do not worry about tomorrow...”</p>
            <h1 className="text_cstm_medium_heading primarycolorcstm">1 Peter 5:7</h1>
            <p className="text_cstm_normal_para textalign_cstmjustify">“Cast all your anxiety on him because he cares for you.”</p>
            <h1 className="text_cstm_medium_heading primarycolorcstm">John 14:27</h1>
            <p className="text_cstm_normal_para textalign_cstmjustify">“Peace I leave with you; my peace I give you...”</p>
            <h1 className="text_cstm_medium_heading primarycolorcstm">Psalm 94:19</h1>
            <p className="text_cstm_normal_para textalign_cstmjustify">“When anxiety was great within me, your consolation brought me joy.”</p>
            <h1 className="text_cstm_medium_heading primarycolorcstm">Philippians 4:6-7</h1>
            <p className="text_cstm_normal_para textalign_cstmjustify">"Do not be anxious about anything... and the peace of God... will guard your hearts.”</p>
        </>
    )
}

export const BibleVerseHopeinDifficultTimes = () => {

    return(
        
        <>
            <h1 className="text_cstm_big_heading">Bible Verses For Hope In Difficult Times</h1>
            <h1 className="text_cstm_medium_heading primarycolorcstm">Romans 8:28</h1>
            <p className="text_cstm_normal_para textalign_cstmjustify">“In all things God works for the good of those who love him...”</p>
            <h1 className="text_cstm_medium_heading primarycolorcstm">Jeremiah 29:11</h1>
            <p className="text_cstm_normal_para textalign_cstmjustify">“For I know the plans I have for you... plans to give you hope and a future..”</p>
            <h1 className="text_cstm_medium_heading primarycolorcstm">Psalm 46:1</h1>
            <p className="text_cstm_normal_para textalign_cstmjustify">“God is our refuge and strength, an ever-present help in trouble.”</p>
            <h1 className="text_cstm_medium_heading primarycolorcstm">2 Corinthians 4:8-9 </h1>
            <p className="text_cstm_normal_para textalign_cstmjustify">“We are hard pressed on every side, but not crushed...”</p>
            <h1 className="text_cstm_medium_heading primarycolorcstm">Romans 15:13</h1>
            <p className="text_cstm_normal_para textalign_cstmjustify">"May the God of hope fill you with all joy and peace as you trust in him...”</p>
        </>
    )
}